define(['angular', 'angular-resource', '../models/campaign'], function (
    angular
) {
    return angular
        .module('campaignServices', ['ngResource', 'campaignModels'])
        .factory('Campaigns', [
            '$resource',
            '$rootScope',
            'CampaignModel',
            function ($resource, $rootScope, CampaignModel) {
                var resource = $resource(
                    $rootScope.Routing.generate('campaigns', {
                        _format: 'json',
                    }),
                    [],
                    {
                        delete: {
                            method: 'DELETE',
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('delete_campaign', {
                                    campaign: ':id',
                                    _format: 'json',
                                })
                            ),
                        },
                        get: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('view_campaign', {
                                    campaign: ':id',
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            params: { id: '@id' },
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse campaign as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new CampaignModel(modelData);
                            },
                        },
                        getCounts: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('campaign_counts', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                        },
                        query: {
                            method: 'GET',
                            isArray: true,
                            transformResponse: function (data) {
                                var modelData = [];
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse campaigns as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                for (i in modelData) {
                                    modelData[i] = new CampaignModel(
                                        modelData[i]
                                    );
                                }
                                return modelData;
                            },
                        },
                        save: {
                            method: 'POST',
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('create_campaign', {
                                    _format: 'json',
                                })
                            ),
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse campaign as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new CampaignModel(modelData);
                            },
                        },
                        send: {
                            method: 'PUT',
                            isArray: false,
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('send_campaign', {
                                    campaign: ':id',
                                    _format: 'json',
                                })
                            ),
                        },
                        update: {
                            method: 'PUT',
                            isArray: false,
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('update_campaign', {
                                    campaign: ':id',
                                    _format: 'json',
                                })
                            ),
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse campaign as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new CampaignModel(modelData);
                            },
                        },
                    }
                );

                var campaigns = false;
                var loadCampaigns = true;
                var lastParams = {};
                var campaignCounts = false;
                return {
                    deleteCampaign: function (campaign, callback) {
                        if (campaign) {
                            var i = campaigns.indexOf(campaign);
                            if (i > -1) {
                                campaigns.splice(i, 1);
                            }
                        }
                        campaign.delete(callback);
                    },
                    getCounts: function (callback) {
                        if (!campaignCounts) {
                            campaignCounts = resource.getCounts();
                        }

                        if (typeof callback == 'function') {
                            campaignCounts.$promise.then(callback);
                        }

                        return campaignCounts;
                    },
                    getCampaigns: function (parameters, callback) {
                        var params = {};
                        angular.forEach(parameters, function (value, key) {
                            // Strip out internal Angular variables because they're causing
                            // some circular reference errors on JSON serialization
                            if (key.indexOf('$') !== 0) {
                                params[key] = value;
                            }
                        });
                        var newParams = false;
                        angular.forEach(params, function (value, key) {
                            if (lastParams[key] != value) {
                                newParams = true;
                            }
                        });
                        angular.forEach(lastParams, function (value, key) {
                            if (params[key] != value) {
                                newParams = true;
                            }
                        });
                        if (newParams || loadCampaigns || params.limit) {
                            lastParams = params;
                            campaigns = resource.query(params);
                            loadCampaigns = false;
                        }
                        if (typeof callback == 'function') {
                            campaigns.$promise.then(callback);
                        }
                        return campaigns;
                    },
                    newCampaign: function () {
                        return new CampaignModel(new resource());
                    },
                    resetCampaigns: function () {
                        loadCampaigns = true;
                    },
                    sendCampaign: function (data, callback) {
                        results = resource.send(data);
                        if (typeof callback == 'function') {
                            results.$promise.then(callback);
                        }
                        return results;
                    },
                    updateCounts: function () {
                        resource.getCounts().$promise.then(function (data) {
                            angular.forEach(data, function (value, key) {
                                campaignCounts[key] = value;
                            });
                        });
                    },
                };
            },
        ]);
});
